/**
    @version 1.0.8
 */

import Vue from "vue";
import makeStore from './store'
import App from "./App.vue";

// load helpers
import bpStory from "./helpers.js";
window.bpStory = bpStory;

Vue.mixin({
    data: () => ({
        bpStory
    })
});

// cookies
import VueCookies from "vue-cookies";
Vue.use(VueCookies);
// set default config
Vue.$cookies.config(((60 * 60 * 24 * 365) * 5));
// set global cookie
Vue.$cookies.set('theme','default');
Vue.$cookies.set('hover-time','1s');

// axios
import axios from 'axios'
import VueAxios from 'vue-axios'
axios.defaults.baseURL = BPSTORY_API_URL;
Vue.use(VueAxios, axios);

Vue.config.productionTip = false;

function createInstance(bpStory) {
    let data = {};
    data.bpStoryId = bpStory.getAttribute('id');
    data.EventBus = new Vue();
    let options = bpStory.getAttribute('data-options');
    if (options) {
        data.options = JSON.parse(options);
    }
    new Vue({
        data,
        store: makeStore(data.bpStoryId, data.EventBus),
        render: (h) => h(App),
    }).$mount(`#${data.bpStoryId}`);
}

if (navigator.cookieEnabled) {
    let bpStories = document.querySelectorAll('.bpstory-placeholder');
    let appStarted = false;
    if (bpStories) {
        bpStories.forEach((bpStory) => {
            if (!appStarted) {
                appStarted = true;
                createInstance(bpStory);
            } else {
                bpStory.innerHTML = 'You can run one BP Story instance on a page.';
            }
        });
    }
} else {
    alert('Please enable cookies for the BP Story plugin to work.');
}